import React from 'react';

/**
 * GameScoreInfo component displays additional score information for a game
 * 
 * @param {Object} props - Component props
 * @param {Array} props.leaderboard - Array of player objects for the game
 * @param {Object} props.userEntry - User entry in the leaderboard
 * @param {boolean} props.isRanked - Whether the player is ranked in this game
 */
function GameScoreInfo({ leaderboard, userEntry, isRanked }) {
  // If no leaderboard or empty leaderboard, return null
  if (!leaderboard || leaderboard.length === 0) {
    return null;
  }

  // Find the highest score (first entry in the leaderboard)
  const highestEntry = leaderboard[0];
  
  // Find the score at rank 50 or the last entry if less than 50 entries
  const leaderboardLength = leaderboard.length;
  const rank50Entry = leaderboardLength >= 50 ? leaderboard[49] : leaderboard[leaderboardLength - 1];

  return (
    <div className="score-info">
      <div className="top-score-section">
        <p><strong>Top Score:</strong> {highestEntry.score?.toLocaleString()}</p>
        
        {isRanked && userEntry && (
          <p className="percentage-info">
            (+{((highestEntry.score - userEntry.score) / userEntry.score * 100).toFixed(1)}% needed)
          </p>
        )}
      </div>

      {isRanked && userEntry ? (
        // Show next rank score if user is ranked
        <div className="next-rank-section">
          {userEntry.rank > 1 && (
            <>
              {/* Find the score that's one rank better */}
              {leaderboard.find(entry => entry.rank === userEntry.rank - 1) && (
                <>
                  <p>
                    <strong>Score to beat #{userEntry.rank - 1}:</strong> {
                      leaderboard.find(entry => entry.rank === userEntry.rank - 1).score?.toLocaleString()
                    }
                  </p>
                  <p className="percentage-info">
                    (+{((leaderboard.find(entry => entry.rank === userEntry.rank - 1).score - userEntry.score) / userEntry.score * 100).toFixed(1)}% needed)
                  </p>
                </>
              )}
            </>
          )}
        </div>
      ) : (
        // Show rank 50 score if user is not ranked
        <div className="rank50-section">
          <p><strong>Score to beat #50:</strong> {rank50Entry.score?.toLocaleString()}</p>
        </div>
      )}
    </div>
  );
}

export default GameScoreInfo;